/* eslint-disable react/no-unknown-property */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { dbInitialDemoData } from '../../../data/DashboardDemoData';
import LayoutProvider from '../../Contexts/LayoutProvider';
import { useTemplate } from '../../features/template/TemplateProvider';
import { GetNumberBeforeZero } from '../../utils/NumberFormatter';
import PageTitle from '../../utils/PageTitle';
import { CustomerIcon, ExpireIcon, InvoiceIcon, PackageIcon } from '../../utils/SVGIcon';
import { mkRelativeUrl } from '../../utils/URL';
import cn from '../../utils/cn';
import { ApiDashboardInitial } from './DashboardOperation';
import FinancialStatistics from './components/FinancialStatistics';
import ProductSales from './components/ProductSales';
import ProductsList from './components/ProductsList';
import ServiceSales from './components/ServiceSales';

function Layout1() {
    return (
        <div className="flex flex-col md:flex-row gap-[15px] 2xl:gap-[25px] justify-between">
            <div className="w-full md:w-[calc(100%_-_300px)] xl:w-[calc(100%_-_450px)] 2xl:w-[calc(100%_-_700px)] rounded-10 md:rounded-[25px] overflow-hidden shadow-[0px_0px_60px_0px_rgba(79,98,130,0.10)]">
                <FinancialStatistics />
            </div>
            <div className="w-full md:w-[300px] xl:w-[400px] 2xl:w-[400px] bg-white rounded-[25px] overflow-hidden shadow-[0px_0px_60px_0px_rgba(79,98,130,0.10)] ">
                <ProductSales />
            </div>
            <div className="w-full md:w-[300px] xl:w-[400px] 2xl:w-[400px] bg-white rounded-[25px] overflow-hidden shadow-[0px_0px_60px_0px_rgba(79,98,130,0.10)] ">
                <ServiceSales />
            </div>
        </div>
    );
}

function Statistics() {
    return (
        <LayoutProvider>
            <Layout1 layout="default" />
        </LayoutProvider>
    );
}

function InfoCard({ path, title, value, icon, bgColor, hoverColor, color, className }) {
    return (
        <Link
            to={path}
            className={cn(
                'bg-white shadow-[0px_0px_60px_0px_rgba(79,98,130,0.10)] inline-flex justify-between items-center rounded-lg lg:rounded-15 xl:rounded-[25px] w-full h-20 lg:h-30 xl:h-[150px] p-1 transition-colors ease-in-out',
                className,
                hoverColor
            )}
        >
            <div className="flex items-center justify-between h-full w-full lg:p-2.5">
                <div className="pl-1.5 lg:pl-2.5 py-2">
                    <h2 className="text-base lg:text-xl font-medium text-[#506B76] md:mb-2 line-clamp-1">
                        <span>{title}</span>
                    </h2>
                    <p className={`text-[35px] leading-10 lg:text-5xl font-medium  ${color}`}>
                        <span>{GetNumberBeforeZero(value)}</span>
                    </p>
                </div>
                <div
                    className={`size-[70px] lg:size-24 xl:size-[130px] h-full rounded-10 lg:rounded-2xl p-[15px] lg:p-5 ${bgColor}`}
                >
                    <span className="size-full">{icon}</span>
                </div>
            </div>
        </Link>
    );
}

function DashboardPage() {
    const { setMessage } = useTemplate();
    const [dbInitialData, setDbInitialData] = useState(dbInitialDemoData);

    useEffect(() => {
        ApiDashboardInitial()
            .then(({ data }) => {
                setDbInitialData(data);
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err.message });
            });
    }, [setMessage]);
    // set page title
    PageTitle(`Dashboard`);
    return (
        <div className="inner_page_cont !p-0 !bg-transparent !h-[calc(100vh_-_90px)]">
            <div
                className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 3xl:grid-cols-4 items-center justify-between gap-1.5 md:gap-2.5 md:3.5 xl:gap-4 2xl:gap-5 mb-3.5 md:mb-7.5 ${
                    dbInitialData.demo ? 'placeholder-mode' : ''
                }`}
            >
                <InfoCard
                    title="Customers"
                    value={dbInitialData?.numOfUsers || 0}
                    color="text-[#3190FF]"
                    bgColor="bg-[rgba(49,44,255,0.10)]"
                    hoverColor="hover:bg-[#F0F7FF]"
                    path="/customers"
                    icon={<CustomerIcon />}
                />
                <InfoCard
                    title="Due Invoice"
                    value={dbInitialData?.numOfPendingInvoice || 0}
                    color="text-[#FFA016]"
                    bgColor="bg-[rgba(255,160,22,0.10)]"
                    hoverColor="hover:bg-[#FFF9F0]"
                    path={mkRelativeUrl('/billing/invoices', { status: 'due' })}
                    icon={<InvoiceIcon />}
                />
                <InfoCard
                    title="Pending Subscription"
                    value={dbInitialData?.numOfPendingSubscription || 0}
                    color="text-[#00916E]"
                    bgColor="bg-[rgba(0,145,110,0.10)]"
                    hoverColor="hover:bg-[#F1FFFC]"
                    path={mkRelativeUrl('/subscriptions/pending')}
                    icon={<PackageIcon />}
                />
                <InfoCard
                    title="Expires Soon"
                    value={dbInitialData?.numOfExpiringSoon || 0}
                    color="text-[#FE4A49]"
                    bgColor="bg-[rgba(254,74,73,0.10)]"
                    hoverColor="hover:bg-[#FFF6F5]"
                    path={mkRelativeUrl('/subscriptions/manage', { status: 'expire-soon' })}
                    icon={<ExpireIcon />}
                />
            </div>
            <Statistics />

            <ProductsList />
        </div>
    );
}
export default DashboardPage;
